<app-walkthrough-slide>
  <div copy class="wt-eyebrow">{{ 'app.pages.auth.walkthrough.pane3.eyebrow' | translate }}</div>
  <h2 copy class="wt-h2">{{ 'app.pages.auth.walkthrough.pane3.title' | translate }}</h2>

  <!-- The chip sentence. Segments, not spans-per-fragment: English puts `{key}`
       late and French puts it before ` : vous les modifiez…`, whose LEADING
       SPACE is French typography the translation owns. Splitting this into
       `body-a` + chip + `body-b` would hard-code the English order. -->
  <p copy class="wt-p">
    @for (segment of 'app.pages.auth.walkthrough.pane3.body' | translateParts; track $index) {
      @if (segment.kind === 'text') {
        <span>{{ segment.text }}</span>
      } @else if (segment.name === 'key') {
        <span class="wt-key">{{ 'app.pages.auth.walkthrough.pane3.key' | translate }}</span>
      }
    }
  </p>

  <div copy class="wt-bul">
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane3.bullet.publish' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane3.bullet.bilingual' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane3.bullet.capture' | translate }}</span>
    </div>
  </div>

  <!-- A still of the form-builder canvas. Five `<div>`s: not draggable, not
       selectable, not focusable, no `cdkDrag` (§12 #22).

       Wrapped because the rows are generated: `select="[viz]"` matches nodes,
       and an `@for` block is not one. See `.vstack`. -->
  <div viz class="vstack">
    @for (field of fields; track field.labelKey) {
      <div
        class="vfield"
        [class.vfield--sel]="field.state === 'selected'"
        [class.vfield--drop]="field.state === 'dropTarget'"
      >
        <ion-icon [name]="field.icon" aria-hidden="true"></ion-icon>
        <span>{{ field.labelKey | translate }}</span>
        <!-- The drop target has no handle: there is nothing in it to grab. -->
        @if (field.state !== 'dropTarget') {
          <ion-icon class="vfield__grab" name="reorder-two-outline" aria-hidden="true"></ion-icon>
        }
      </div>
    }
  </div>
</app-walkthrough-slide>
